import React from "react";
import ToggleButtonGroup from "@common/components/shared/forms/ToggleButtonGroup";

const ToggleFieldType = ({ value, label, onToggle }) => (
  <ToggleButtonGroup
    value={value}
    options={[
      { value: true, text: "Show" },
      { value: false, text: "Hide" },
    ]}
    onToggle={onToggle}
    label={label}
    fieldStyle="flex-between flow-row-center my-1"
    labelStyle="text-16px"
    showButtonOr={false}
  />
);

export default ToggleFieldType;
